// // import { createContext, useContext, useState, useEffect } from 'react';
// // import axios from 'axios';

// // const AuthContext = createContext();

// // export const AuthProvider = ({ children }) => {
// //   const [authState, setAuthState] = useState({
// //     schoolId: null,
// //     schoolName: '',
// //     isLoading: false,
// //   });

// //   const schoolLogin = async (email, schoolCode) => {
// //     setAuthState(prev => ({ ...prev, isLoading: true }));

// //     try {
// //       const response = await axios.post('https://kidsm.vercel.app/api/schools/login', {
// //         email: email.trim().toLowerCase(),
// //         schoolCode: schoolCode.trim()
// //       });

// //       if (response.data && response.data.schoolId) {
// //         setAuthState({
// //           schoolId: response.data.schoolId,
// //           schoolName: response.data.schoolName || '',
// //           isLoading: false
// //         });

// //         localStorage.setItem('schoolAuth', JSON.stringify({
// //           schoolId: response.data.schoolId,
// //           schoolName: response.data.schoolName
// //         }));

// //         return {
// //           schoolId: response.data.schoolId,
// //           schoolName: response.data.schoolName
// //         };
// //       }

// //       throw new Error(response.data?.message || 'Login failed');
// //     } catch (error) {
// //       console.error('Login error:', error);
// //       throw error;
// //     } finally {
// //       setAuthState(prev => ({ ...prev, isLoading: false }));
// //     }
// //   };

// //   const logout = () => {
// //     localStorage.removeItem('schoolAuth');
// //     setAuthState({
// //       schoolId: null,
// //       schoolName: '',
// //       isLoading: false
// //     });
// //   };

// //   const checkAuthState = () => {
// //     const schoolAuth = localStorage.getItem('schoolAuth');
// //     if (schoolAuth) {
// //       const { schoolId, schoolName } = JSON.parse(schoolAuth);
// //       setAuthState(prev => ({
// //         ...prev,
// //         schoolId,
// //         schoolName
// //       }));
// //     }
// //   };

// //   useEffect(() => {
// //     checkAuthState();
// //   }, []);

// //   return (
// //     <AuthContext.Provider value={{
// //       ...authState,
// //       schoolLogin,
// //       logout
// //     }}>
// //       {children}
// //     </AuthContext.Provider>
// //   );
// // };

// // export const useAuth = () => {
// //   const context = useContext(AuthContext);
// //   if (!context) {
// //     throw new Error('useAuth must be used within an AuthProvider');
// //   }
// //   return context;
// // };

// import { createContext, useContext, useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [authState, setAuthState] = useState({
//     schoolId: null,
//     schoolName: '',
//     authToken: null, // Keep for compatibility, but not used in login
//     isLoading: false,
//   });

//   const schoolLogin = async (email, schoolCode) => {
//     setAuthState(prev => ({ ...prev, isLoading: true }));

//     try {
//       const response = await axios.post('https://kidsm.vercel.app/api/schools/login', {
//         email: email.trim().toLowerCase(),
//         schoolCode: schoolCode.trim(),
//       });

//       if (response.data && response.data.schoolId) {
//         const authData = {
//           schoolId: response.data.schoolId,
//           schoolName: response.data.schoolName || '',
//           authToken: response.data.token || null, // Handle token if present, else null
//         };

//         setAuthState({
//           ...authData,
//           isLoading: false,
//         });

//         localStorage.setItem('schoolAuth', JSON.stringify(authData));

//         return authData;
//       }

//       throw new Error(response.data?.message || 'Login failed');
//     } catch (error) {
//       console.error('Login error:', error);
//       throw new Error(error.response?.data?.message || 'Invalid email or school code.');
//     } finally {
//       setAuthState(prev => ({ ...prev, isLoading: false }));
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('schoolAuth');
//     setAuthState({
//       schoolId: null,
//       schoolName: '',
//       authToken: null,
//       isLoading: false,
//     });
//   };

//   const checkAuthState = () => {
//     const schoolAuth = localStorage.getItem('schoolAuth');
//     if (schoolAuth) {
//       const { schoolId, schoolName, authToken } = JSON.parse(schoolAuth);
//       setAuthState({
//         schoolId,
//         schoolName,
//         authToken,
//         isLoading: false,
//       });
//     }
//   };

//   useEffect(() => {
//     checkAuthState();
//   }, []);

//   return (
//     <AuthContext.Provider
//       value={{
//         ...authState,
//         schoolLogin,
//         logout,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };


import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    schoolId: null,
    schoolName: '',
    isLoading: false,
    verificationEmail: null,
    requiresVerification: false,
  });

  const schoolLogin = async (email, schoolCode, verificationCode = null) => {
    setAuthState(prev => ({ ...prev, isLoading: true }));

    try {
      // If verification code is provided, use the verification endpoint
      if (verificationCode) {
        const verificationResponse = await axios.post('https://kidsm.vercel.app/api/schools/login', {
          email: email.trim().toLowerCase(),
          schoolCode: schoolCode.trim(),
          verificationCode: verificationCode.trim().toUpperCase()
        });

        if (verificationResponse.data && verificationResponse.data.schoolId) {
          const schoolData = {
            schoolId: verificationResponse.data.schoolId,
            schoolName: verificationResponse.data.schoolName || ''
          };

          setAuthState({
            ...schoolData,
            isLoading: false,
            verificationEmail: null,
            requiresVerification: false
          });

          localStorage.setItem('schoolAuth', JSON.stringify(schoolData));
          return schoolData;
        }
        throw new Error(verificationResponse.data?.message || 'Login failed');
      } 
      // Otherwise, initiate the login process
      else {
        const loginResponse = await axios.post('https://kidsm.vercel.app/api/schools/login', {
          email: email.trim().toLowerCase(),
          schoolCode: schoolCode.trim()
        });

        // If verification is required
        if (loginResponse.data && loginResponse.data.requiresVerification) {
          setAuthState(prev => ({
            ...prev,
            verificationEmail: email.trim().toLowerCase(),
            requiresVerification: true,
            isLoading: false
          }));
          return { requiresVerification: true };
        }
        // If direct login is successful
        else if (loginResponse.data && loginResponse.data.schoolId) {
          const schoolData = {
            schoolId: loginResponse.data.schoolId,
            schoolName: loginResponse.data.schoolName || ''
          };

          setAuthState({
            ...schoolData,
            isLoading: false,
            verificationEmail: null,
            requiresVerification: false
          });

          localStorage.setItem('schoolAuth', JSON.stringify(schoolData));
          return schoolData;
        }
        throw new Error(loginResponse.data?.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      throw new Error(error.response?.data?.message || error.message || 'Login failed. Please try again.');
    } finally {
      setAuthState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const resendVerificationCode = async (email, schoolCode) => {
    setAuthState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await axios.post('https://kidsm.vercel.app/api/schools/login', {
        email: email.trim().toLowerCase(),
        schoolCode: schoolCode.trim()
      });

      if (response.data && response.data.requiresVerification) {
        return true;
      }

      throw new Error(response.data?.message || 'Failed to resend code');
    } catch (error) {
      console.error('Resend code error:', error);
      throw new Error(error.response?.data?.message || error.message || 'Failed to resend code. Please try again.');
    } finally {
      setAuthState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const logout = () => {
    localStorage.removeItem('schoolAuth');
    setAuthState({
      schoolId: null,
      schoolName: '',
      isLoading: false,
      verificationEmail: null,
      requiresVerification: false,
    });
  };

  const checkAuthState = () => {
    const schoolAuth = localStorage.getItem('schoolAuth');
    if (schoolAuth) {
      const { schoolId, schoolName } = JSON.parse(schoolAuth);
      setAuthState(prev => ({
        ...prev,
        schoolId,
        schoolName
      }));
    }
  };

  useEffect(() => {
    checkAuthState();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        ...authState,
        schoolLogin,
        resendVerificationCode,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
